import React, { useEffect, useRef, useState } from "react";
import NavBar from "../communs/NavBar";
import { AppDispatch, RootState } from "../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import headerBg from "../../assets/images/seasonal-projects.png";
import headerMobileBg from "../../assets/background/seasonal-projects-Mob.png";
import HeroSectionDetailsProject from "./layout-details-project/HeroSectionDetailsProject";
import {
  getAllProjectsTypes,
  getSeasonalProjects,
  getGeneralProjects,
} from "../../apis/actions/projects.actions";
import ComposedCard from "../../biblio/Cards/ComposedCard";
import PaginationComponent from "../../biblio/Pagination/PaginationComponent";
import Loader from "../../biblio/Loader/Loader";
import FooterSection from "../../components/sections/FooterSection";
import pray from "../../assets/icons/SelectIcon.svg";
import { ConfigProvider, Empty, Input, Select } from "antd";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { LeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { scroll } from "../../components/utils/utils";
const { Search } = Input;
// TEMPORARY: search/filter header hidden on the projects pages (seasonal & general) — REQUESTED BY CLIENT
const SHOW_SEARCH_HEADER: boolean = false;
const itemPerPage = 8;

interface ProjectsProps {
  projectType?: "seasonal" | "general";
  title: string;
  subtitle: string;
}
const Projects: React.FC<ProjectsProps> = ({
  projectType = "seasonal",
  title,
  subtitle,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const seasonalProjects = useSelector(
    (state: RootState) => state?.projects?.seasonalProjects
  );
  const currentRef = useRef<HTMLDivElement>(null);
  const projectTypes = useSelector(
    (state: RootState) => state?.projects?.projectTypes
  );
  const generalProjects = useSelector(
    (state: RootState) => state?.projects?.projects
  );

  const [projectsToDisplay, setProjectsToDisplay] = useState<any[]>([]);
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [active, setActive] = useState<number>(1);
  const [loading, setLoading] = useState(true);
  const [projectName, setProjectName] = useState("");
  const [filteredProject, setFilteredProject] = useState<any[]>([]);

  useEffect(() => {
    if (projectType === "seasonal") {
      dispatch(getSeasonalProjects());
    } else {
      dispatch(getGeneralProjects());
    }
    dispatch(getAllProjectsTypes());
  }, [dispatch, projectType]);
  useEffect(() => {
    if (projectType === "seasonal") {
      setProjectsToDisplay(seasonalProjects);
    } else {
      setProjectsToDisplay(generalProjects);
    }
  }, [seasonalProjects, generalProjects, projectType]);

  useEffect(() => {
    setFilteredProject(projectsToDisplay);
  }, [projectsToDisplay]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [projectsToDisplay]);

  const updateActive = (nb: number) => {
    setActive(nb);
    scroll(currentRef);
  };
  const onSearch = (selectedProjectType: any, projectName: string) => {
    setActive(1);
    if (selectedProjectType === null && projectName === "") {
      setFilteredProject(projectsToDisplay);
      return;
    }

    const filtered = projectsToDisplay.filter(
      (project: any) =>
        (!selectedProjectType ||
          project.request_type_id === selectedProjectType) &&
        (!projectName ||
          project.project_name.includes(projectName) ||
          project.brief.includes(projectName))
    );

    setFilteredProject(filtered);
  };

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <div className="takaful--projects-container">
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title={title}
        subTitle={subtitle}
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type={"المشاريع"}
      />
      <div
        className="takaful--cases-section"
        style={{ marginTop: "2vh" }}
        ref={currentRef}
      >
        {SHOW_SEARCH_HEADER && (
          <div className="takaful--cases-header">
            <div className="takaful--cases-header-content">
              <div className="takaful--cases-header-box">
                <img src={pray} alt="" />
                <ConfigProvider
                  renderEmpty={() => (
                    <Empty
                      description={
                        <span className="takaful--select-empty">
                          لا توجد بيانات
                        </span>
                      }
                    />
                  )}
                >
                  <Select
                    key="22"
                    showSearch
                    popupMatchSelectWidth={300}
                    className={`takaful--select takaful--selects`}
                    size="large"
                    placeholder="اختر نوع المشروع"
                    onChange={(e: any) => {
                      e
                        ? setSelectedProjectType(
                            projectTypes.filter((el: any) => el.id === e)[0]?.name
                          )
                        : setSelectedProjectType(null);
                    }}
                    options={[
                      ...projectTypes.map((option: any) => ({
                        label: option.name,
                        value: option.id,
                      })),
                    ]}
                    dropdownRender={(menu: any) => (
                      <div className="takaful--select-dropdown">{menu}</div>
                    )}
                    allowClear
                    onClear={() => {
                      onSearch(null, projectName);
                    }}
                  />
                </ConfigProvider>
              </div>
              <Search
                className="takaful--search"
                placeholder="ادخل كلمة البحث"
                allowClear
                enterButton
                onPressEnter={() => {
                  onSearch(selectedProjectType, projectName);
                }}
                onClear={() => onSearch(selectedProjectType, "")}
                type="text"
                onChange={(e) => setProjectName(e.target.value)}
              />
              <PrimaryButton
                className="takaful--primary-button"
                icon={<LeftOutlined />}
                title={t("cases.button")}
                onClick={() => onSearch(selectedProjectType, projectName)}
              />
            </div>
          </div>
        )}
      </div>
      <div>
        <div className="takaful--cases-section">
          <div className="takaful--cases " style={{ marginTop: "3rem" }}>
            {projectsToDisplay.length === 0 ? (
              <p className="takaful--no-project-message">لا يوجد مشاريع</p>
            ) : filteredProject.length === 0 ? (
              <p className="takaful--no-project-message">
                لا يوجد مشاريع تتوافق مع البحث الذي قمت به
              </p>
            ) : (
              filteredProject
                .slice(itemPerPage * (active - 1), itemPerPage * active)
                .map((project: any, index: number) => (
                  <ComposedCard
                    donation_type_ids={project.donation_type_ids}
                    key={index}
                    type="المشاريع"
                    project={project}
                    cardClass={"card-1"}
                  />
                ))
            )}
          </div>
        </div>
      </div>
      {filteredProject && filteredProject.length > itemPerPage && (
        <PaginationComponent
          active={active}
          scroll={() => scroll(currentRef)}
          total={filteredProject.length}
          itemPerPage={itemPerPage}
          setActive={(nb) => updateActive(nb)}
        />
      )}
      <FooterSection />
    </div>
  );
};

export default Projects;
